<template>
	<div class="pga-tournament-pool-home-page">
		<div class="pga-tournament-pool-home-page__content">
			<div class="pool-data" v-if="pool != null">
				<h3 class="pool-name">{{ pool.name }}</h3>
				<router-link class="pool-data--manage-entry" :to="{ name: 'pga-tournament-pools-manage-entry', params: { poolId: pool.id, entryId: userEntryId } }" v-if="!pool.pga_tournament.event.underway">Manage Entry</router-link>
				<div class="pool-data--entry-list" v-if="!pool.pga_tournament.event.underway">
					<div class="header">
						<p>Entries</p>
					</div>
					<div class="entry" v-for="entry in pool.entries" :key="entry.id">
						<p class="entry--name">{{ entry.user.name }}</p>
					</div>
				</div>
				<div class="pool-data--results" v-else>
					<div class="tabs">
						<button class="tab-button overall" :class="{ 'active-tab': tab == 0 }" @click="tab = 0">Overall</button>
						<button class="tab-button" :class="{ 'active-tab': tab == 1 }" @click="tab = 1">R1</button>
						<button class="tab-button" :class="{ 'active-tab': tab == 2 }" @click="tab = 2">R2</button>
						<button class="tab-button" :class="{ 'active-tab': tab == 3 }" @click="tab = 3">R3</button>
						<button class="tab-button" :class="{ 'active-tab': tab == 4 }" @click="tab = 4">R4</button>
					</div>
					<div class="overall" v-if="tab == 0">
						<div class="header">
							<p class="position"></p>
							<p class="entry">Entry</p>
							<p class="round">R1</p>
							<p class="round">R2</p>
							<p class="round">R3</p>
							<p class="round">R4</p>
							<p class="winner">Winner</p>
							<p class="total">Total</p>
						</div>
						<div class="entries">
							<div class="entry" v-for="(entry, index) in entries" :key="entry.id">
								<p class="position">{{ entry.position }}</p>
								<p class="name">{{ entry.name }}</p>
								<p class="round-score">{{ entry.round_one.score }}</p>
								<p class="round-score">{{ entry.round_two.score }}</p>
								<p class="round-score">{{ entry.round_three.score }}</p>
								<p class="round-score">{{ entry.round_four.score }}</p>
								<p class="winner-score">{{ entry.winner.score }}</p>
								<p class="total" :class="{ 'white-underline':  index != entries.length - 1}">{{ entry.total }}</p>
							</div>
						</div>
					</div>
					<div class="rounds" v-for="(tournamentRound, index) in tournamentRounds" :key="index">
						<div class="round" v-if="tab == index + 1">
							<div class="header">
								<p class="position"></p>
								<p class="entry">Entry</p>
								<p class="best-score" v-if="pool.tournament_scoring_data.lowest_rounds[tournamentRound] != null">Best Score:<span>{{ pool.tournament_scoring_data.lowest_rounds[tournamentRound] }}</span></p>
							</div>
							<div class="entries">
								<div class="entry" v-for="entry in sortedRounds(tournamentRound)" :key="entry.id">
									<div class="entry-name">
										<p class="position"></p>
										<p class="entry">{{ entry.name }}</p>
										<p class="score">{{ entry[tournamentRound].score }}</p>
									</div>
									<div class="entry-players" v-for="(round,index) in entry[tournamentRound].rounds" :key="index">
										<p class="position-filler"></p>
										<p class="entry-player" :class="{ 'not-scored': index >= 5, 'inactive': !round.active }">{{ round.player }} <span :class="{ 'under-par': round.score_to_par < 0 }" v-if="round.active">( {{ round.score_to_par }} )</span></p>
										<p class="score" :class="{ 'not-scored': index >= 5 }">{{ round.roundScore }}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapMutations, mapGetters } from 'vuex'
	import axios from '@/axios'

	export default {
		props: ['poolId'],
		data() {
			return {
				pool: null,
				tab: 0,
				timer: '',
				tournamentRounds: [
					'round_one',
					'round_two',
					'round_three',
					'round_four'
				]
			}
		},
		computed: {
			...mapGetters([
				'authenticated'
			]),
			userEntryId() {
				var id = 0
				if("entries" in this.pool) {
					this.pool.entries.forEach(function(element) {
						if(element.current_user_entry) {
							id = element.id
						}
					})
				}

				return id
			},
			entries() {
				return this.getEntries()
			},
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			getPgaTournamentPool() {
				return axios.get('pga-tournament-pools/' + this.poolId).then((response) => {
					this.pool = response.data.data
				})
			},
			getEntries() {
				var entries = []
				this.pool.entries.forEach((entry) => {
					var round1Score = this.roundScore(entry, 1, 'round_one')
					var round2Score = this.roundScore(entry, 2, 'round_two')
					var round3Score = this.roundScore(entry, 3, 'round_three')
					var round4Score = this.roundScore(entry, 4, 'round_four')
					var winner = this.winner(entry)
					var total = round1Score + round2Score + round3Score + round4Score + winner
					entries.push({
						name: entry.user.name,
						round_one: {
							score: round1Score,
							rounds: this.roundRounds(entry, 1, 'round_one')
						},
						round_two: {
							score: round2Score,
							rounds: this.roundRounds(entry, 2, 'round_two')
						},
						round_three: {
							score: round3Score,
							rounds: this.roundRounds(entry, 3, 'round_three')
						},
						round_four: {
							score: round4Score,
							rounds: this.roundRounds(entry, 4, 'round_four')
						},
						winner: {
							score: winner
						}, 
						total: total,
						position: ''
					})
				})

				entries.sort((a,b) => {
					return b.total - a.total
				})

				var position = 1
				if (entries.length == 1) {
					entries[0].position = '1'
				} else {
					entries.forEach((entry, index) => {
						if (index == 0) {
							if (entry.total == entries[1].total) {
								entry.position = 'T' + position
							} else {
								entry.position = position.toString()
							}
						} else if (index < (entries.length - 1)) {
							if (entry.total == entries[index - 1].total) {
								entry.position = 'T' + position
							}
							if (entry.total < entries[index - 1].total) {
								position = (index + 1)
								if (entry.total == entries[index + 1].total) {
									entry.position = 'T' + position
								} else {
									entry.position = position.toString()
								}
							}
						} else if (index == (entries.length -1)) {
							if (entry.total == entries[index - 1].total) {
								entry.position = 'T' + position
							} else {
								position = index + 1
								entry.position = position.toString()
							}
						}
					})
				}
				return entries
			},
			sortedRounds(round) {
				var sortedEntries = this.getEntries()

				return sortedEntries.sort(function(a,b) {
					return b[round].score - a[round].score
				})
			},
			roundScore(entry, roundNumber, roundName) {
				var defaultScore = Math.min(20, (10 + this.pool.tournament_scoring_data.lowest_rounds[roundName]) * 2)
				var scores = []
				entry.selections.forEach((selection) => {
					if (selection.pga_tournament_player.tournament_rounds.length == (roundNumber - 1) && this.pool.tournament_scoring_data.lowest_rounds[roundName] !== null) {
						if (selection.pga_tournament_player.active) {
							scores.push(defaultScore)
						} else {
							scores.push(0)
						}
						
					} else {
						selection.pga_tournament_player.tournament_rounds.forEach((round) => {
							if (round.round_number == roundNumber) {
								if (round.score_to_par - this.pool.tournament_scoring_data.lowest_rounds[roundName] <= 9) {
									scores.push((10 - (round.score_to_par - this.pool.tournament_scoring_data.lowest_rounds[roundName])) * 2)
								}
							}
						})
					}
				})
				return scores.sort(function(a,b) { 
					return b - a
				}).splice(0, 5).reduce((a, b) => a + b, 0)
			},
			winner(entry) {
				var score = 0
				if (this.pool.tournament_scoring_data.current_leader == null) {
					return score
				}
				entry.selections.forEach((selection) => {
					if (selection.pga_tournament_player.id == this.pool.tournament_scoring_data.current_leader.id) {
						score = 10
					}
				})
				return score
			},
			roundRounds(entry, roundNumber, roundName) {
				var rounds = []
				entry.selections.forEach((selection) => {
					if (!selection.pga_tournament_player.active && selection.pga_tournament_player.tournament_rounds.length < roundNumber) {
						rounds.push({
							player: selection.pga_tournament_player.pga_player.first_name + ' ' + selection.pga_tournament_player.pga_player.last_name,
							score_to_par: '',
							roundScore: 0, 
							active: false
						})
					} else if(this.pool.tournament_scoring_data.lowest_rounds[roundName] == null) {
						rounds.push({
							player: selection.pga_tournament_player.pga_player.first_name + ' ' + selection.pga_tournament_player.pga_player.last_name,
							score_to_par: 'E',
							roundScore: 0, 
							active: true
						})
					} else {
						var roundScore = Math.min(20, (10 + this.pool.tournament_scoring_data.lowest_rounds[roundName]) * 2)
						var scoreToPar = 0
						selection.pga_tournament_player.tournament_rounds.forEach((round) => {
							if (round.round_number == roundNumber) {
								scoreToPar = round.score_to_par
								roundScore = Math.max(0, (10 - (round.score_to_par - this.pool.tournament_scoring_data.lowest_rounds[roundName])) * 2)
							}
						})
						if (scoreToPar == 0) {
							scoreToPar = 'E'
						}
						if (scoreToPar > 0) {
							scoreToPar = '+' + scoreToPar
						}
						rounds.push({
							player: selection.pga_tournament_player.pga_player.first_name + ' ' + selection.pga_tournament_player.pga_player.last_name,
							score_to_par: scoreToPar,
							roundScore: roundScore,
							active: true
						})
					}
				})
				return rounds.sort(function(a,b) {
					var bValue = b.roundScore
					if(b.active == false) {
						bValue = -1
					}
					var aValue = a.roundScore
					if(a.active == false) {
						aValue = -1
					}
					return bValue - aValue
				})
			},
			cancelAutoUpdate() { clearInterval(this.timer) }
		},
		created() {
			this.HTTP_IN_PROGRESS()
			this.getPgaTournamentPool().then(() => {
				this.HTTP_FINISHED()
			}).catch(() => {
				this.HTTP_FINISHED()
				this.$router.replace('/')
			})
			this.timer = setInterval(this.getPgaTournamentPool, 60000)
		},
		beforeDestroy() {
			clearInterval(this.timer)
		}
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/pga/pga-tournament-pool/home';
</style>